import React, { useEffect } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "../PolicyLayout.css";

const ShippingPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Force solid header on policy page */}
      <Header forceSolid={true} />

      <div className="policy-page">
        <div className="policy-container">
          <h1 className="policy-title">Shipping Policy</h1>

          <h2>Domestic Shipping</h2>
          <p>
            We offer reliable shipping to all domestic locations. Orders are
            typically processed within 1–2 business days, with standard delivery
            times ranging from 3–5 business days. For orders over $50, enjoy
            complimentary standard shipping. Expedited shipping options are
            available at an additional cost.
          </p>

          <h2>International Shipping</h2>
          <p>
            Our products are available globally, with shipping rates and
            delivery times varying by destination. International shipping may
            take 7–21 business days, depending on customs and local postal
            services. Please note that international customers are responsible
            for any customs fees, taxes, or duties incurred.
          </p>

          <h2>Shipping Costs</h2>
          <p>
            Shipping costs are calculated based on the weight and dimensions of
            your order, as well as the shipping destination. To estimate shipping
            costs, add items to your cart and proceed to checkout, where you can
            enter your address and view the calculated shipping fees.
          </p>

          <h2>Tracking Your Order</h2>
          <p>
            Once your order is dispatched, you will receive a confirmation email
            with a tracking number. You can use this number to track the progress
            of your shipment on our website or directly through the courier's
            tracking system.
          </p>

          <h2>Shipping Delays</h2>
          <p>
            While we do our best to ensure timely delivery, occasionally shipping
            may be affected by factors beyond our control, such as weather
            conditions or logistical delays. We appreciate your patience and
            understanding in these situations.
          </p>

          <h2>Packaging</h2>
          <p>
            All items are securely packaged to ensure they arrive in perfect
            condition. We use eco-friendly materials wherever possible, as part
            of our commitment to sustainability.
          </p>

          <h2>Contact Us</h2>
          <p>
            For any shipping-related inquiries or if you need assistance with
            your order, please contact our customer service team at{" "}
            <strong>shipping@wondertheme.com</strong>.
          </p>
        </div>
      </div>

      {/* <Footer /> */}
    </>
  );
};

export default ShippingPolicy;